export const navOne = [{
        first: "A:",
        tent: [{
            ig: 0,
            name: "安徽省"
        }]
    },
    {
        first: "B:",
        tent: [
            // { ig: 1, name: '部本级' },
            {
                ig: 2,
                name: '北京市'
            }]
    },
    {
        first: "C:",
        tent: [{
            ig: 3,
            name: "重庆市"
        }]
    },
    {
        first: "F:",
        tent: [{
            ig: 4,
            name: "福建省"
        }]
    }
]
export const navTwo = [{
        first: "G:",
        tent: [{
            ig: 5,
            name: "甘肃省"
        }, {
            ig: 6,
            name: "广东省"
        }, {
            ig: 7,
            name: "广西壮族自治区"
        }, {
            ig: 8,
            name: "贵州省"
        }]
    },
    {
        first: "H:",
        tent: [{
            ig: 9,
            name: "海南省"
        }, {
            ig: 10,
            name: "河北省"
        }, {
            ig: 11,
            name: "黑龙江省"
        }, {
            ig: 12,
            name: "河南省"
        }, {
            ig: 13,
            name: "湖南省"
        }, {
            ig: 14,
            name: "湖北省"
        }]
    }
]
export const navThree = [{
    first: "J:",
    tent: [{
            ig: 15,
            name: "江苏省"
        }, {
            ig: 16,
            name: "江西省"
        }, {
            ig: 17,
            name: "吉林省"
        }

    ]
}, {
    first: "L:",
    tent: [{
        ig: 18,
        name: "辽宁省"
    }]
}, {
    first: "N:",
    tent: [{
            ig: 19,
            name: "内蒙古自治区"
        }, {
            ig: 20,
            name: "宁夏回族自治区"
        }

    ]
}, {
    first: "Q:",
    tent: [{
        ig: 21,
        name: "青海省"
    }]
}]
export const navFive = [{
    first: "S:",
    tent: [{
            ig: 22,
            name: "山东省"
        }, {
            ig: 23,
            name: "上海市"
        }, {
            ig: 24,
            name: "山西省"
        }, {
            ig: 25,
            name: "陕西省"
        }, {
            ig: 26,
            name: "四川省"
        }

    ]
}, {
    first: "T:",
    tent: [{
        ig: 27,
        name: "天津市"
    }]
}]
export const navSixs = [{
    first: "X:",
    tent: [{
        ig: 28,
        name: "新疆兵团"
    }, {
        ig: 29,
        name: "新疆维吾尔自治区"
    }, {
        ig: 30,
        name: "西藏自治区"
    }]
}]
export const navSix = [{
    first: "Y:",
    tent: [{
        ig: 31,
        name: "云南省"
    }]
}, {
    first: "Z:",
    tent: [{
        ig: 32,
        name: "浙江省"
    }]
}, ]
